import request from './request'

export const saveBook = data => {
    return request({
        url: '/book/saveBook',
        method: 'POST',
        data
    })
}
export const getBookDetail = id => {
    return request({
        url: '/book/getBookDetail',
        method: 'POST',
        data: { id }
    })
}
export const getPedigreeBookList = () => {
    return request({
        url: '/book/getPedigreeBookList',
        method: 'POST',
        data: {}
    })
}

export const removeBook = id => {
    return request({
        url: '/book/removeBook',
        method: 'POST',
        data: {
            id
        }
    })
}
